import StatusBadge from './StatusBadge'
import { ColorVariant } from './types'

export default StatusBadge
export { ColorVariant }
